export const SESSION_REFRESH_POLICY = {
  maxRefreshCheckIntervalMs: 55 * 60 * 1000,
  maxRefreshBufferMs: 5 * 60 * 1000,
  minRefreshBufferMs: 1000,
  minRefreshCheckDelayMs: 1000,
  refreshBufferRatio: 1 / 12
} as const;

export function getSessionRefreshCheckDelayMs(
  expiry: string | Date | null | undefined,
  nowMs = Date.now()): number {
  if (!expiry) {
    return SESSION_REFRESH_POLICY.maxRefreshCheckIntervalMs;
  }

  const expiryMs = expiry instanceof Date ? expiry.getTime() : new Date(expiry).getTime();
  if (!Number.isFinite(expiryMs)) {
    return SESSION_REFRESH_POLICY.maxRefreshCheckIntervalMs;
  }

  const msUntilExpiry = expiryMs - nowMs;
  if (msUntilExpiry <= 0) {
    return 0;
  }

  const bufferMs = Math.min(
    SESSION_REFRESH_POLICY.maxRefreshBufferMs,
    Math.max(
      SESSION_REFRESH_POLICY.minRefreshBufferMs,
      msUntilExpiry * SESSION_REFRESH_POLICY.refreshBufferRatio
    )
  );
  const delayMs = Math.min(
    SESSION_REFRESH_POLICY.maxRefreshCheckIntervalMs,
    msUntilExpiry - bufferMs
  );

  return Math.max(SESSION_REFRESH_POLICY.minRefreshCheckDelayMs, delayMs);
}
